import { FetchContext } from '../fetch-context';
import { ProgramDate } from '../../models';
import { responseErrorHandler } from '../response-error-handler';

export const getProgramDatesForStaff: (
  fetchContext: FetchContext,
  programId: number,
  accessToken?: string,
) => Promise<ProgramDate[]> = (fetchContext, programId, accessToken) => fetch(`${fetchContext.baseUrl}/api/staff/programs/${programId}/program-dates`,
  {
    method: 'GET',
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<ProgramDate[]>(fetchContext.errorStore, response, 'get program dates for staff'));
